/* ===== AI Reveal (Reusable) ===== */
(function () {
  if (window.__aiRevealInit) return; // prevent duplicates
  window.__aiRevealInit = true;

  function revealInit(root = document) {
    const containers = root.querySelectorAll('[data-ai-reveal]');
    if (!containers.length) return;

    containers.forEach((container) => {
      const items = container.querySelectorAll('.ai-reveal');
      if (!items.length) return;

      // If no IntersectionObserver, reveal immediately
      if (!('IntersectionObserver' in window)) {
        items.forEach((el) => el.classList.add('is-visible'));
        return;
      }

      const threshold = parseFloat(container.dataset.aiRevealThreshold || '0.25');
      const once = container.dataset.aiRevealOnce !== 'false';

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            if (once) io.unobserve(entry.target);
          }
        });
      }, { threshold });

      items.forEach((el) => io.observe(el));
    });
  }

  // Run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => revealInit(), { once: true });
  } else {
    revealInit();
  }

  // Shopify editor + dynamic section loads
  document.addEventListener('shopify:section:load', (e) => revealInit(e.target));
  document.addEventListener('shopify:block:select', (e) => revealInit(e.target));
})();
